// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddFormatEditor_wrapper__3RRI1","addFormatRow":"AddFormatEditor_addFormatRow__m7K0l","multipleModalContent":"AddFormatEditor_multipleModalContent__3mLNy"};